module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.auth.mail),
      callback: function($$v) {
        _vm.$set(_vm.auth, "mail", $$v)
      },
      expression: "auth.mail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "パスワード",
      "type": 'password',
      "rules": _vm.passowordRules,
      "required": ""
    },
    model: {
      value: (_vm.auth.password),
      callback: function($$v) {
        _vm.$set(_vm.auth, "password", $$v)
      },
      expression: "auth.password"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b894ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/parts/login.vue
// module id = 484
// module chunks = 1